import { makeAutoObservable, runInAction } from 'mobx';
import { Employee } from '../types/employee.types';
import { employeeService } from '../services/employee.service';

export class EmployeeStore {
  employees: Employee[] = [];
  loading: boolean = false;
  error: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  async loadEmployees() {
    this.loading = true;
    this.error = null;
    try {
      const data = await employeeService.getAllEmployees();
      runInAction(() => {
        this.employees = data;
        this.loading = false;
      });
    } catch (err: any) {
      runInAction(() => {
        this.error = err.message || 'Ошибка загрузки сотрудников';
        this.loading = false;
      });
    }
  }

  async createEmployee(name: string): Promise<Employee | null> {
    try {
      const newEmployee = await employeeService.createEmployee({ name });
      runInAction(() => {
        this.employees = [newEmployee, ...this.employees];
      });
      return newEmployee;
    } catch (err: any) {
      runInAction(() => {
        this.error = err.message || 'Ошибка создания сотрудника';
      });
      return null;
    }
  }

  async updateEmployeeStatus(id: number, is_active: boolean): Promise<boolean> {
    try {
      const updatedEmployee = await employeeService.updateEmployeeStatus(id, { is_active });
      runInAction(() => {
        const index = this.employees.findIndex(emp => emp.id === id);
        if (index !== -1) {
          this.employees[index] = updatedEmployee;
        }
      });
      return true;
    } catch (err: any) {
      runInAction(() => {
        this.error = err.message || 'Ошибка обновления статуса';
      });
      return false;
    }
  }

  get activeEmployees(): Employee[] {
    return this.employees.filter(emp => emp.is_active);
  }

  get archivedEmployees(): Employee[] {
    return this.employees.filter(emp => !emp.is_active);
  }
}
